import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzRowCardVariant } from './sz-row-card.types';

@Component({
  selector: 'sz-row-card',
  templateUrl: './sz-row-card.component.html',
  styleUrls: ['./sz-row-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzRowCardComponent {
  readonly variant: InputSignal<SzRowCardVariant> = input<SzRowCardVariant>('flat');
  readonly interactive: InputSignal<boolean> = input<boolean>(false);
}
